import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './ImageRenderer.module.scss';

const ImageRenderer = ({ src, alt, className, ...props }) => {

    const [resolvedSrc, setResolvedSrc] = useState(null);

    useEffect(() => {
        let isMounted = true;

        // Check if src is a promise (i.e. if it has a .then function)
        if (src && typeof src.then === 'function') {
            src
                .then(url => {
                    if (isMounted) setResolvedSrc(url);
                })
                .catch(error => {
                    console.error('Error loading image src:', error);
                    // Optionally, set an error placeholder or similar
                });
        } else {
            setResolvedSrc(src);
        }

        // Cleanup in case the component unmounts before promise resolves
        return () => {
            isMounted = false;
        };
    }, [src]);

    const handleLoad = (e) => {
        // If you're using CSS modules for the loaded state:
        e.target.classList.add(styles.loaded);
    };

    // You might want to display a placeholder while the image source is pending
    if (!resolvedSrc) {
        return <div className={`${styles.imagePlaceholder} ${className || ''}`}></div>;
    }

    return (
        <img
            src={resolvedSrc}
            alt={alt}
            onLoad={handleLoad}
            className={`${styles.imageRenderer} ${className || ''}`}
            {...props}
        />
    );
};

ImageRenderer.propTypes = {
    src: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Promise)
    ]).isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default ImageRenderer;
